"use strict";
// Time utilities
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMomentToDateType = exports.convertDateToMoment = exports.getPixelsFromDuration = exports.getDurationFromPixels = exports.getPixelAtTime = exports.getTimeAtPixel = exports.getSnapPixelFromDelta = exports.pixelsPerMillisecond = exports.timeSnap = void 0;
var moment_1 = __importDefault(require("moment"));
/**
 * Snaps a moment object to the given resolution
 * @param {moment} time The moment to snap
 * @param {number} snapMilliseconds The snap time in milliseconds
 * @returns {moment} Snapped moment
 */
function timeSnap(time, snapMilliseconds) {
    if (snapMilliseconds === 0) {
        var newTime = time.clone();
        newTime.set('millisecond', 0);
        return newTime;
    }
    var newUnix = Math.round((time.unix() * 1000) / snapMilliseconds) * snapMilliseconds;
    return (0, moment_1.default)(newUnix);
}
exports.timeSnap = timeSnap;
/**
 * Get the pixels per millisecond
 * @param {moment} vis_start The moment specifying the start of the visible timeline range
 * @param {moment} vis_end The moment specifying the end of the visible timeline range
 * @param {number} total_width The width of the timeline in pixels
 * @returns {float} The pixels per millisecond
 */
function pixelsPerMillisecond(vis_start, vis_end, total_width) {
    var start_end_ms = vis_end.diff(vis_start, 'milliseconds');
    return total_width / start_end_ms;
}
exports.pixelsPerMillisecond = pixelsPerMillisecond;
/**
 *
 * @param {number} delta the delta distance in pixels
 * @param {moment} vis_start the visible start of the timeline
 * @param {moment} vis_end  the visible end of the timeline
 * @param {number} total_width  the pixel width of the timeline
 * @param {number} snapMilliseconds the number of milliseconds to snap to
 */
function getSnapPixelFromDelta(delta, vis_start, vis_end, total_width, snapMilliseconds) {
    if (snapMilliseconds === void 0) { snapMilliseconds = 0; }
    var pixelsPerSnapSegment = pixelsPerMillisecond(vis_start, vis_end, total_width) * snapMilliseconds;
    return Math.round(delta / pixelsPerSnapSegment) * pixelsPerSnapSegment;
}
exports.getSnapPixelFromDelta = getSnapPixelFromDelta;
/**
 * Get the time at a pixel location
 * @param {number} pixel_location the pixel location (generally from left css style)
 * @param {moment} vis_start The visible start of the timeline
 * @param {moment} vis_end The visible end of the timeline
 * @param {number} total_width The pixel width of the timeline (row portion)
 * @param {number} snapMilliseconds The snap resolution (in ms)
 * @returns {moment} Moment object
 */
function getTimeAtPixel(pixel_location, vis_start, vis_end, total_width, snapMilliseconds) {
    if (snapMilliseconds === void 0) { snapMilliseconds = 0; }
    var min_offset = pixel_location / pixelsPerMillisecond(vis_start, vis_end, total_width);
    var timeAtPix = vis_start.clone().add(min_offset, 'milliseconds');
    if (snapMilliseconds !== 0)
        timeAtPix = timeSnap(timeAtPix, snapMilliseconds);
    return timeAtPix;
}
exports.getTimeAtPixel = getTimeAtPixel;
/**
 * Get the pixel location at a specific time
 * @param  {objects} time The time (moment) object
 * @param  {moment} vis_start The visible start of the timeline
 * @param  {moment} vis_end The visible end of the timeline
 * @param  {number} total_width The width in pixels of the grid
 * @returns {number} The pixel offset
 */
function getPixelAtTime(time, vis_start, vis_end, total_width) {
    var min_from_start = time.diff(vis_start, 'milliseconds');
    return min_from_start * pixelsPerMillisecond(vis_start, vis_end, total_width);
}
exports.getPixelAtTime = getPixelAtTime;
/**
 * Returns the duration from the {@link vis_start}
 * @param  {number} pixels
 * @param  {moment} vis_start The visible start of the timeline
 * @param  {moment} vis_end The visible end of the timeline
 * @param  {number} total_width The width in pixels of the grid
 * @returns {moment} Moment duration
 */
function getDurationFromPixels(pixels, vis_start, vis_end, total_width) {
    var start_end_ms = vis_end.diff(vis_start, 'milliseconds');
    if (start_end_ms === 0)
        return moment_1.default.duration(0, 'milliseconds');
    var pixels_per_ms = total_width / start_end_ms;
    var millis = pixels / pixels_per_ms;
    return moment_1.default.duration(millis, 'milliseconds');
}
exports.getDurationFromPixels = getDurationFromPixels;
/**
 * @param  {duration} the duration in milliseconds
 * @param  {moment} vis_start The visible start of the timeline
 * @param  {moment} vis_end The visible end of the timeline
 * @param  {number} total_width The width in pixels of the grid
 */
function getPixelsFromDuration(duration, vis_start, vis_end, total_width, snapMilliseconds) {
    if (snapMilliseconds === void 0) { snapMilliseconds = 0; }
    if (snapMilliseconds !== 0)
        duration = Math.round(duration / snapMilliseconds) * snapMilliseconds;
    return duration * pixelsPerMillisecond(vis_start, vis_end, total_width);
}
exports.getPixelsFromDuration = getPixelsFromDuration;
/**
 * If `useMoment` is `true` then returns `date` as is. Otherwise converts `date` to
 * a moment object.
 *
 * @param {moment|number} date
 * @param {boolean} useMoment
 * @returns moment
 */
function convertDateToMoment(date, useMoment) {
    if (useMoment) {
        return date;
    }
    return (0, moment_1.default)(date);
}
exports.convertDateToMoment = convertDateToMoment;
/**
 * If `useMoment` is `true` returns `dateAsMoment` as is. Otherwise it converts `dateAsMoment` to
 * number/milliseconds.
 *
 * @param {moment} dateAsMoment
 * @param {boolean} useMoment
 * @returns a moment object or a number/milliseconds
 */
function convertMomentToDateType(dateAsMoment, useMoment) {
    if (useMoment) {
        return dateAsMoment;
    }
    return dateAsMoment.valueOf();
}
exports.convertMomentToDateType = convertMomentToDateType;
//# sourceMappingURL=timeUtils.js.map